import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { loadingFade, modal, alert } from '../../animacoes';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FiltroManutencoesPipe } from '../pipes/filtro-manutencoes.pipe';
import { FiltroChecklistPipe } from '../pipes/filtro-checklist.pipe';


import { DespesaService } from '../services/despesa.service';
import { ManutencaoService } from '../services/manutencao.service';
import { ItemDespesaService} from '../services/item-despesa.service';
import { VeiculoService } from '../services/veiculo.service';
import { AuthService } from '../services/auth.service';
import { ExcelService } from '../services/excel.service';
import { PerfilUsuarioService } from '../services/perfil-usuario.service';

import * as Datepicker from 'js-datepicker';
import * as moment from 'moment';
import Swal from 'sweetalert2';

@Component({
	selector: 'app-manutencao',
	templateUrl: './manutencao.component.html',
	styleUrls: ['./manutencao.component.css'],
	animations: [loadingFade, modal, alert]
})
export class ManutencaoComponent implements OnInit {

	//Id do menu da tb_menu
	public menu_id = 114; //checklist	
	
	public loading = false;
	public despesas = [];
	public veiculos = [];
	public itens;
	
	// paginacao
	public page = 1;
	public limit = 10;
	public count = 0;

	// filtro
	public filtro = [];
	public dadosFiltrados = [];
	public filtered = false;
	public formFiltro: FormGroup;
	public showFilter = true;

		//acesso
		public usuario_perfil;
		public visualizar = true;
		public editar = false;

	constructor(private fb: FormBuilder,
				private authSvc: AuthService,
				private despesaSvc: DespesaService,
				private manutencaoSvc: ManutencaoService,
				private itemDespesaSvc: ItemDespesaService,
				private veiculoSvc: VeiculoService,
				private route: ActivatedRoute,
				private router: Router,	
				private excelSvc: ExcelService,
				private perfilUsuarioSvc: PerfilUsuarioService) { }

	ngOnInit() {

		//Verifica Permissões Acesso
		this.usuario_perfil = this.authSvc.getPerfil();
		this.perfilUsuarioSvc.getByVerificaPermissao(this.usuario_perfil,this.menu_id).then((data: any[]) => {
		if(data[0].editar){
			this.editar = true;
		}
		}).catch((err) => {
		console.log(err);
		});  

		this.criaFiltro();
		this.pegaVeiculos();
		this.pegaDespesas();
	}

	criaFiltro() {
		this.formFiltro = this.fb.group({
			despesa_valor___valorMin: '',
			despesa_valor___valorMax: '',
			despesa_data_compra___data_i: null,
			despesa_data_compra___data_f: null,
			veiculo_id___veiculo_id: null
		});

		let campos_data = ['despesa_data_compra___data_i', 'despesa_data_compra___data_f'];
		moment.locale('pt-Br');
		for (let campo of campos_data) {
			Datepicker('#' + campo, {
				customMonths: moment.months(),
				customDays: moment.weekdaysShort(),
				overlayPlaceholder: 'Preencha o ano',
				overlayButton: 'Enviar',
				formatter: (element, date) => {
					let formatted = moment(date).format('DD/MM/YYYY');
					this.formFiltro.controls[campo].setValue(formatted);
				}
			});
		}

		this.route.params.subscribe( params => {

			if(params.id){
	  
			  let splitF = params.id.split("&");
	  
			  let loValorMin = null;
			  let loValorMax = null;
			  let loData_i = "";
			  let loData_f = "";
			  let loVeiculo_id = null;
	  
			  //this.showFilter = false;
	  
			  for (var i = 0; i < splitF.length; i++) {
	  
				var loSplitValor = splitF[i].split("=");
	  
				switch(loSplitValor[0]) { 
				  case "despesa_valor___valorMin": { 
					if(loSplitValor[1] !== "null"){
						this.showFilter = false;
						loValorMin = parseInt(loSplitValor[1]);
					}
					 break; 
				  } 
				  case "despesa_valor___valorMax": { 
					if(loSplitValor[1] !== "null"){
						this.showFilter = false;
						loValorMax = loSplitValor[1];
					}
					break; 
				  }  
				  case "despesa_data_compra___data_i": { 
					if(loSplitValor[1] !== "null"){
						this.showFilter = false;
					  let splitDate1 = loSplitValor[1].split("-");
					  if(splitDate1){
						loData_i = splitDate1[2] + "/" + splitDate1[1] + "/" + splitDate1[0];
					  }
					}
					 break; 
				  }      
				  case "despesa_data_compra___data_f": { 
					if(loSplitValor[1] !== "null"){
						this.showFilter = false;
					  let splitDate1 = loSplitValor[1].split("-");
					  if(splitDate1){
						loData_f = splitDate1[2] + "/" + splitDate1[1] + "/" + splitDate1[0];
					  }
					}
					 break; 
				  }      
				  case "veiculo_id___veiculo_id": { 
					if(loSplitValor[1] !== "null"){
						this.showFilter = false;
						loVeiculo_id =  parseInt(loSplitValor[1]);
					}
					 break; 
				  }                                                      
				 }
	  
			  }
			  this.preencheForm({
				despesa_valor___valorMin: loValorMin,
				despesa_valor___valorMax: loValorMax,
				despesa_data_compra___data_i: loData_i,
				despesa_data_compra___data_f: loData_f,
				veiculo_id___veiculo_id: loVeiculo_id									
	  
			  });
			  this.filtra();
	  
			}
	  
		  });

	}


	preencheForm(dados) {
		this.formFiltro.setValue(dados);
	}  


	pegaDespesas() {
		this.despesas = [];
		this.loading = true;
		this.manutencaoSvc.getManutencoesByUsuario(this.authSvc.getUsuarioId()).then((data: any) => {
		// this.despesaSvc.getByUsuarioAndTipo(this.authSvc.getUsuarioId(), 1).then((data: any) => {
			this.despesas = data;
			this.count = this.despesas.length;
			this.loading = false;
		}).catch((err) => {
			console.log(err);
			this.loading = false;
		})
	}

	pegaItens(despesaId){
		this.itens = [];
		this.loading = true;
		this.itemDespesaSvc.getItensDespesa(despesaId).then((data: any[]) => {
			this.itens = data;
			this.count = this.despesas.length;
			this.loading = false;
		}).catch((err) => {
			console.log(err);
			this.loading = false;
		})
	}

	pegaVeiculos(){
		this.veiculoSvc.getVeiculosActiveByUsuario(this.authSvc.getUsuarioId()).then((data: any) =>{
		  this.veiculos = data;
		}).catch((err) => {
		  console.log(err);
		});
	  }

	/*pegaVeiculos(){
		this.veiculos = [];
		this.loading = true;
		this.veiculoSvc.getVeiculosByUsuario(this.authSvc.getUsuarioId()).then((data: any) => {
			let dados = [];
			console.log("data = ", data);
			for(let veiculo of data){
				if(veiculo.veiculo_isento == 'N')
					dados.push(veiculo);
			}
			this.veiculos = dados;
		}).catch((err) => {
			console.log(err);
		});
	}*/
	

	primPagina() {
		this.page = 1;
	}

	paginaAnt() {
		this.page = Math.max(this.page - 1, 1);
	}

	proxPagina() {
		this.page = Math.min(this.page + 1, Math.ceil(this.count / this.limit));
	}

	ultPagina() {
		this.page = Math.ceil(this.count / this.limit);
	}

	filtra() {

		this.filtro = this.formFiltro.value;
		this.dadosFiltrados = new FiltroManutencoesPipe().transform(this.despesas, this.filtro);
		this.count = this.dadosFiltrados.length;
		this.filtered = true;
		this.page = 1;
	}

	apagaDespesa(id) {
		Swal.fire({
			type:'warning',
			title: 'Deseja realmente apagar este registro?',
			showCancelButton: true,
			showCloseButton: true,
			confirmButtonText: 'Apagar',
			cancelButtonText: 'Cancelar',
			confirmButtonColor: '#d33'
			  
		}).then((result) => {
			if(result.value == true){
				this.itemDespesaSvc.limpaItensDespesa(id).then(() => {
					this.manutencaoSvc.apagaManutencao(id).then((data) => {
						this.pegaDespesas();
						Swal.fire({
							type: 'success',
							title: 'Apagado com sucesso!'
						});
					}).catch((err) => {
						console.log(err);
						Swal.fire({
							type: 'error',
							title: 'Ops! Algo de errado aconteceu!',
							text: 'Não foi possível apagar este registro, tente novamente mais tarde.'
						});
					});
				});
			}
		})
		
	}

	exportarExcel(){
		let data = [];
		if(this.filtered == false){
			this.dadosFiltrados = this.despesas;
		}
		for(let index in this.dadosFiltrados){
			data[index] = {
				'Veículo': this.dadosFiltrados[index].veiculo.veiculo_placa,
				'Data contrato': moment(this.dadosFiltrados[index].seguro_data_contrato).format('DD/MM/YYYY'),
				'Data vencimento': moment(this.dadosFiltrados[index].seguro_vigencia).format('DD/MM/YYYY'),
				'Valor': this.dadosFiltrados[index].seguro_valor,
				'Descrição': this.dadosFiltrados[index].seguro_descricao,
			};
		}
		this.excelSvc.exportAsExcelFile(data, 'Chronos Frota - Manutencoes Realizadas');
	}

	expandPanel(){
		this.showFilter = this.showFilter == true ? false: true;
	}


	EditManutencao(manutencao_id){

		this.filtro = this.formFiltro.value;
	
		let params = '';
	
		for (let f in this.filtro) {
		  let val = this.filtro[f];
		  if (val) {
			let aux = f.split('___');
			if (aux[1] == 'data_i' || aux[1] == 'data_f')
			  val = moment(val, 'DD/MM/YYYY').format('YYYY-MM-DD');
	
			params += (params == '')? '?' : '&';
			params += f + "=" + val;
		  }
		}
	
		this.router.navigate(['home/manutencao/edit/' + manutencao_id + params]);
	  }


}
